import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PenLine } from 'lucide-react';
import { Button } from '@pisaka/ui';
import { useModal } from '../../../hooks/useModal';
import { MODAL_NAME_CREATE_FONT } from '../../../constants/modalNamesConstants';

const EmptyFontCreatorContainer: FC = () => {
  const { t } = useTranslation();
  const { onOpenModal } = useModal(MODAL_NAME_CREATE_FONT);

  return (
    <div className="flex items-center justify-center h-emptyHeightWithInfo px-6">
      <div className="flex flex-col items-center gap-4 text-center max-w-sm">
        <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center">
          <PenLine className="w-8 h-8 text-muted-foreground" />
        </div>
        <div>
          <p className="text-base font-semibold">{t('fontCreator.emptyTitle')}</p>
          <p className="text-sm text-muted-foreground mt-1">{t('fontCreator.emptyDescription')}</p>
        </div>
        <Button
          onClick={onOpenModal}
          className="bg-gradient-accent hover:bg-accent shadow-accent text-primary-foreground"
        >
          {t('fontCreator.emptyCreateButton')}
        </Button>
      </div>
    </div>
  );
};

export default EmptyFontCreatorContainer;
